export default "__VITE_ASSET__bb388168__"